<template>
 <div class="m-2">
     <icon-view
        :has-border="false"
        icon="fas fa-info-circle color-orange"
        icon-size="1rem"
        title="Información de la Denegación"
        variant="custom-icon-view"
    />
    <br>
    <div class="row mb-5 custom-ml-4">
     <div class="col-md-3 col-sm-12">
        <div class="text-title regular text-gray">
          <span>Fecha de la Determinación:</span>
        </div>
        <span class="text-title">
        {{data.determinationDate | date}}
        </span>
     </div>
    <div class="col-md-3 col-sm-12">
<div class="text-title regular text-gray">
          <span>Determinado por:</span>
        </div>
        <span class="text-title">
         {{data.determinationMadeBy | empty}}
        </span>
    </div>
     <div class="col-md-3 col-sm-12">
<div class="text-title regular text-gray">
          <span>Razón:</span>
        </div>
        <span class="text-title">
        {{data.denegationReason | empty}}
        </span>
     </div>
          <div class="col-md-12 col-sm-12 mt-3">
<div class="text-title regular text-gray">
          <span>Comentario:</span>
        </div>
        <span class="text-title">
        {{data.determinationComment | empty}}
        </span>
     </div>
    </div>
     
 </div>
</template>

<script>
import IconView from 'icon-view';
export default {
  name: 'RlvDetermination',
  components: {
   IconView
  },
  props:{
      data: {
      type: Object,
    },
  }, 
};
</script>

<style lang="scss" scoped>

.custom-ml-4{
     margin-left: 30px;
}
</style>
